import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const ModalContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`

export const StepTitle = styled.h3`
  margin-top: 0;
`

export const QRCodeContainer = styled.div`
  text-align: center;
  margin: 20px 0;
`

export const ButtonGroup = styled.div`
  margin-top: 28px;
  display: flex;
  gap: 10px;
`

export const CodesContainer = styled.div`
  border: 1px solid ${colors.gray220};
  border-radius: 4px;
  padding: 15px;
  background-color: ${colors.gray190};
  margin-top: 15px;
`

export const CodesGrid = styled.div`
  font-family: monospace;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 15px;
  font-size: 14px;
`

export const CodesButtonRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 32px;
`

export const ConfirmForm = styled.form`
  > div {
    width: 240px;
  }
`

export const IntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 16px;
  gap: 24px;
`

export const IntroText = styled.p`
  font-size: 15px;
  margin: 0;
  line-height: 1.6;
`
